import React, { useState, useEffect } from 'react';
import { newContact } from '../helpers/newsletter';
import '../css/newsletter-kiosk.css';

const translations = {
  fr: {
    title: 'Restez connecté avec le MACTe',
    subtitle: 'Inscrivez-vous à notre newsletter et recevez les dernières actualités, événements et temps forts du MACTe directement dans votre boîte mail.',
    firstname: 'Prénom',
    lastname: 'Nom',
    optional: '(facultatif)',
    email: 'Adresse email',
    required: '*',
    firstnamePlaceholder: 'Votre prénom',
    lastnamePlaceholder: 'Votre nom',
    emailPlaceholder: 'Votre adresse email',
    submit: "S'inscrire",
    submitting: 'Inscription...',
    privacy: 'En vous inscrivant, vous acceptez de recevoir des communications du MACTe. Vous pouvez vous désinscrire à tout moment.',
    successTitle: 'Merci !',
    successMessage: 'Votre inscription a bien été enregistrée.',
    successReset: 'Retour au formulaire dans quelques secondes...',
    error: 'Une erreur est survenue, veuillez réessayer.',
  },
  en: {
    title: 'Stay connected with the MACTe',
    subtitle: 'Subscribe to our newsletter and receive the latest news, events, and highlights from the MACTe straight to your inbox.',
    firstname: 'First name',
    lastname: 'Last name',
    optional: '(optional)',
    email: 'Email address',
    required: '*',
    firstnamePlaceholder: 'Your first name',
    lastnamePlaceholder: 'Your last name',
    emailPlaceholder: 'Your email address',
    submit: 'Subscribe',
    submitting: 'Subscribing...',
    privacy: 'By subscribing, you agree to receive communications from the MACTe. You may unsubscribe at any time.',
    successTitle: 'Thank you!',
    successMessage: 'Your subscription has been successfully registered.',
    successReset: 'Returning to the form in a few seconds...',
    error: 'An error occurred, please try again.',
  },
};

const NewsletterKiosk = () => {
  const [email, setEmail] = useState('');
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [lang, setLang] = useState('fr');

  const t = translations[lang];

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
        setEmail('');
        setFirstname('');
        setLastname('');
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await newContact(email, firstname, lastname);

      if (response.success) {
        setSuccess(true);
      } else {
        setError(t.error);
      }
    } catch (e) {
      console.error('Error during subscription:', e);
      setError(t.error);
    } finally {
      setLoading(false);
    }
  };

  const langSwitcher = (
    <div className="kiosk-lang-switcher">
      <button
        className={`kiosk-lang-btn ${lang === 'fr' ? 'active' : ''}`}
        onClick={() => setLang('fr')}
        type="button"
      >
        FR
      </button>
      <button
        className={`kiosk-lang-btn ${lang === 'en' ? 'active' : ''}`}
        onClick={() => setLang('en')}
        type="button"
      >
        EN
      </button>
    </div>
  );

  if (success) {
    return (
      <div className="kiosk-container kiosk-success">
        {langSwitcher}
        <div className="kiosk-content">
          <div className="success-icon">&#10003;</div>
          <h1>{t.successTitle}</h1>
          <p>{t.successMessage}</p>
          <p className="reset-notice">{t.successReset}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="kiosk-container">
      {langSwitcher}
      <div className="kiosk-logo">
        <span className="logo-memorial">Mémorial</span>
        <span className="logo-acte">ACTe</span>
      </div>
      <div className="kiosk-content">
        <div className="kiosk-header">
          <h1>{t.title}</h1>
          <p>{t.subtitle}</p>
        </div>

        <form onSubmit={handleSubmit} className="kiosk-form">
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="firstname">{t.firstname} <span className="optional">{t.optional}</span></label>
              <input
                type="text"
                id="firstname"
                value={firstname}
                onChange={(e) => setFirstname(e.target.value)}
                placeholder={t.firstnamePlaceholder}
                className="kiosk-input"
              />
            </div>
            <div className="form-group">
              <label htmlFor="lastname">{t.lastname} <span className="optional">{t.optional}</span></label>
              <input
                type="text"
                id="lastname"
                value={lastname}
                onChange={(e) => setLastname(e.target.value)}
                placeholder={t.lastnamePlaceholder}
                className="kiosk-input"
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="email">{t.email} <span className="required">{t.required}</span></label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t.emailPlaceholder}
              className="kiosk-input"
              required
            />
          </div>

          {error && <p className="kiosk-error">{error}</p>}

          <button
            type="submit"
            className="kiosk-button"
            disabled={loading || !email}
          >
            {loading ? t.submitting : t.submit}
          </button>
        </form>

        <p className="kiosk-privacy">
          {t.privacy}
        </p>
      </div>
    </div>
  );
};

export default NewsletterKiosk;
